<template>
	<div>
		<table class="table table-striped table-bordered default-table" :class="tableClass" tabindex="0">
			<thead>
				<tr>
					<th v-if="showSelect" tabindex="0" scope="col"><span class="sr-only">Select</span></th>
					<th v-for="(column, columnIndex) in columns"
							:width="column.headMaxWidth || 'auto'"
							v-show="showColumn( column )"
							:class="headerClasses"
							tabindex="0"
							scope="col"
							:key="`table_header_${columnIndex}`">
						{{ column.heading }}
						<button type="button"
										class="btn btn-unstyled btn-fixed"
										data-container="body"
										data-toggle="popover"
										data-placement="top"
										v-if="column.popover && column.popover !== ''"
										:title="column.heading"
										:data-content="column.popover">
							<i class="fa fa-question-circle"></i>
						</button>
					</th>
					<slot name="actions">
						<th v-if="showActions" class="action-header">{{ actionsHeader }}</th>
					</slot>
				</tr>
			</thead>
			<tbody>
				<slot name="data-row"></slot>
				<slot name="append-list"></slot>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		name: 'TableEditableList',
		props: {
			columns: {
				type: Array,
				required: true
			},
			headerClasses: {
				type: String,
				default: '',
			},
			showSelect: {
				type: Boolean,
				required: false,
				default: false
			},
			showActions: {
				type: Boolean,
				required: false
			},
			showColumns: {
				type: Array,
				default: function() {
					return []
				}
			},
			tableClass: {
				Type: Object,
				default: function() {
					return {}
				}
			},
			actionsHeader: {
				Type: String,
				default: 'Actions'
			}
		},
		methods: {
			showColumn(column) {
				if(+this.showColumns.length === 0 ) return true;
				let exists = this.showColumns.map( function( e ) { return e.key; }).indexOf( column.key );
				if(exists >= 0) {
						return true;
				} else {
					return false
				}
			}
		}
	}
</script>
